import type { ReduxState } from '@/redux/app/state';

export const userAudioSelector = (state: ReduxState) =>
  state.user.audio;
